<svelte:options tag="webster-footer" />

<script>
	import { onMount } from 'svelte';
	import '../src/websterfooter.css';
	export let base = '';
	const fullyear = new Date().getFullYear();
</script>

<link rel="stylesheet" type="text/css" href="{base}/build/websterfooter.dist.css">

<footer id="footer" role="contentinfo" class="chasTest footer wb-ocd-component">
	<div class="sitefooter-bottom">
		<div class="sitefooter-fdic"></div>
		<div class="sitefooter-bottomcontainer">
			<div class="sitefooter-menu">
				<div class="menu-footer-container">
					<ul id="menu-footer" class="shortcode-menu">
						<li id="menu-item-2125" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2125"><a href="https://www.websterbank.com/security/">Security</a></li>
						<li id="menu-item-2126" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2126"><a href="https://www.websterbank.com/legal/">Legal</a></li>
						<li id="menu-item-2129" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2129"><a href="https://www.websterbank.com/privacy/">Privacy</a></li>
						<li id="menu-item-17586" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17586"><a href="https://www.websterbank.com/security/protect-yourself/disclosure-fees/">Disclosures and Fees</a></li>
						<li id="menu-item-2990" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2990"><a href="https://www.websterbank.com/accessibility-statement/">Accessibility Statement</a></li>
						<li id="menu-item-2127" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2127"><a href="https://www.websterbank.com/about/accessibility/">Accessible Banking</a></li>
						<li id="menu-item-2128" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2128"><a href="https://www.websterbank.com/site-map/">Sitemap</a></li>
					</ul>
				</div>
			</div>
			<div class="sitefooter-copyright">
				<p>Webster Bank, N.A.<br>
					Webster, Webster Bank, the Webster Bank logo and the W symbol<br>
					are trademarks of Webster Financial Corporation and<br>
					registered in the U.S. Patent and Trademark Office.<br>
					&copy; <span id="footer_copyright_year">{fullyear}</span> Webster Financial Corporation. All rights reserved.</p>
			</div>
		</div>
	</div>
</footer>

<style>

</style>
